import {initializeOrDestroyPlayer} from "./components/heroVimeo";
import {createRoot} from "react-dom/client";
import DynamicSearch from "./components/DynamicSearch";
import React from "react";

window.addEventListener( "DOMContentLoaded", () => {
  // Update to react 18 render method.
  [...document.getElementsByClassName( "denhaag-search-form--autocomplete" )]?.forEach( (element, searchBoxIndex) => createRoot( element )?.render(
    <DynamicSearch
      id={element.getAttribute( "id" )}
      endpoint='rest_api_url_autocomplete'
      searchBoxIndex={`autocomplete-${searchBoxIndex}`}
    />
  ) );

  initializeOrDestroyPlayer()
} );
window.addEventListener( "dh:resize", () => initializeOrDestroyPlayer() );
